export default __webpack_public_path__ + "static/media/industry-our-products.8ce52dac.jpg";